var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLineDividerIcon = function SvgLineDividerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A8B0",
    strokeLinecap: "round",
    d: "M.5.5v19"
  })));
};
export default SvgLineDividerIcon;